<template>
    <div ref="info" class="info  flex flex-direction">
        <el-button
            class="self-end"
            type="primary"
            @click="addLabel(false,0)"
        >添加
        </el-button>
        <el-table
            :data="lists"
            border
            class="margin-tb-sm"
            header-row-class-name="table-header"
            row-class-name="table-row"
            row-key="id"
            style="width: 100%"
            default-expand-all
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            tooltip-effect="dark">
            <el-table-column label="序号" prop="index" width="220">
                <template slot-scope="scope">
                    {{ scope.row.index }}
                </template>
            </el-table-column>
            <el-table-column label="标签名称" prop="title">
            </el-table-column>
            <el-table-column
                label="操作"
                width="150">
                <template slot-scope="scope">
                    <el-button size="small" type="text" @click="addLabel(scope.row)">编辑
                    </el-button>
                    <el-button size="small" type="text" @click="addLabel(false,scope.row.id)" v-if="scope.row.level === 1">添加
                    </el-button>
                    <el-button size="small" type="text" @click="delLabel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="showDialog"
            center
            title="添加标签"
            width="480px">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto">
                <el-form-item label="标签名称" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="请输入标签名称">
                    </el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('ruleForm')">提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

import {addInformationLabel, delInformationLabel, getInformationLabel, updateInformationLabel} from "@/api/admin";

export default {
    name: "info",
    data() {
        return {
            lists: [],
            ruleForm: {
                title: ''
            },
            rules: {
                title: [{required: true, message: '请输入标签名称', trigger: 'blur'}],
            },
            cur_pid: 0,
            cur_id: '',
            showDialog: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/admin/creditList', "信用信息情况  / 互动标签管理", true, 'icon-yonghu');
        this.init()
    },
    components: {},
    methods: {
        //  获取基本信息
        async init() {
            let _data = await getInformationLabel()
            _data.data.map((item,index)=>{
                item.level = 1
                item.index = index + 1
                if (item.children && item.children.length > 0) {
                    item.children.map((children,pos)=>{
                        children.level = 2
                        children.index =`${ item.index}-${pos + 1}`
                    })
                }
            })
            this.lists = _data.data
        },
        addLabel(data,pid) {
            this.cur_pid = pid
            if (data) {
                this.cur_id = data.id
                this.ruleForm = {
                    title: data.title,
                }
            } else {
                this.cur_id = ''
                this.ruleForm = {
                    title: '',
                }
            }
            this.showDialog = true
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submit()
                } else {
                    this.$message.error('信息填写不完整，请检查修改！')
                }
            })
        },
        async submit() {
            let _data = this.cur_id ? await updateInformationLabel(this.cur_id, this.ruleForm.title,this.cur_pid) : await addInformationLabel(this.ruleForm.title,this.cur_pid)
            if (_data.status === 200) {
                this.$message.success('操作成功')
                this.resetForm()
            } else {
                this.$message.error(_data.msg)
            }
            this.init()
        },
        resetForm() {
            this.cur_id = ''
            this.showDialog = false
        },
        delLabel(item) {
            this.$confirm('此操作将删除选择的标签, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDel(item.id)
            })

        },
        async sureDel(id) {
            let _state = await delInformationLabel(id)
            if (_state.status === 200) {
                this.$message.success('操作成功')
            } else {
                this.$message.error(_state.msg)
            }
            this.init()
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.info {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    min-height: calc(100vh - 180px);
    overflow: auto;

    .mune-title {
        font-size: 16px;
        color: #0d7fd7;
        padding-left: 20px;
        position: relative;
        line-height: 24px;

        &.first {
            font-size: 20px;

            &:before {
                position: absolute;
                top: 0;
                left: 0;
                content: "";
                width: 5px;
                height: 24px;
                background-color: #0d7fd7;
                border-radius: 2px;
            }
        }
    }

    .xieyi {
        font-size: 14px;
        line-height: 24px;
        padding-left: 50px;
        color: #666;

        p {
            text-indent: 32px;
        }
    }

    .agree {
        width: 220px;
        margin: 0 auto;
    }
}
</style>
